import throwConfetti from '../throwConfetti.js'

export default {
  data () {
    return {
      nextConfettiInterval: undefined,
    }
  },

  computed: {
    confettiSettings () { return this.custom('confetti_celebration_settings') || {} },
    confettiInterval () { return this.confettiSettings.interval },
    confettiStat () { return this.$store.getters.dogStat( this.confettiSettings.type ) },
  },

  methods: {
    setNextInterval (currentNum) {
      this.nextConfettiInterval = currentNum - (currentNum % this.confettiInterval) + this.confettiInterval;
    },
  },

  watch: {
    confettiStat (newVal) {
      if (this.nextConfettiInterval === undefined) {
        this.setNextInterval(newVal);
      } else if (newVal >= this.nextConfettiInterval) {
        this.setNextInterval(newVal);
        throwConfetti({seconds: this.confettiSettings.seconds, message: this.confettiSettings.message});
      }
    },
  }
}
